<template>
  <div class="signup">
    <v-form class="login-form" ref="form" v-model="isValid" lazy-validation>
      <!-- Username -->
      <div class="field-block">
        <div class="field-label">
          {{ $t("broker.login.newUsers.username") }}
        </div>
        <v-text-field
          v-model="form.username"
          :placeholder="$t('broker.login.newUsers.chooseUsername')"
          outlined
          dense
          :rules="[rules.required, rules.username]"
          hide-details="auto"
        />
      </div>

      <!-- Password -->
      <div class="field-block">
        <div class="field-label">
          {{ $t("broker.login.newUsers.password") }}
        </div>
        <v-text-field
          v-model="form.password"
          :type="showPassword ? 'text' : 'password'"
          :placeholder="$t('broker.login.newUsers.createPassword')"
          outlined
          dense
          :rules="[rules.required, rules.password]"
          hide-details="auto"
          :append-icon="
            showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
          "
          @click:append="showPassword = !showPassword"
        />
      </div>

      <!-- Confirm password -->
      <div class="field-block">
        <div class="field-label">
          {{ $t("broker.login.newUsers.confirmPassword") }}
        </div>
        <v-text-field
          v-model="form.confirmPassword"
          :type="showConfirm ? 'text' : 'password'"
          :placeholder="$t('broker.login.newUsers.reenterPassword')"
          outlined
          dense
          :rules="[rules.required, rules.matchesPassword]"
          hide-details="auto"
          :append-icon="showConfirm ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
          @click:append="showConfirm = !showConfirm"
        />
      </div>

      <!-- Button -->
      <v-btn
        block
        depressed
        class="signup-btn"
        :disabled="!canSubmit || loading"
        :loading="loading"
        @click="onSubmit"
      >
        {{ $t("broker.login.newUsers.signUp") }}
      </v-btn>

      <!-- Legal text -->
      <p class="signup-two__legal">
        {{ $t("broker.login.newUsers.signupDisclaimer") }}
      </p>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "SignUpNewUserTwo",
  props: {
    brokerName: { type: String, default: "Broker name" },
    invitedEmail: { type: String, default: "" },
    initialUsername: { type: String, default: "" },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      isValid: false,
      showPassword: false,
      showConfirm: false,
      form: {
        email: "",
        username: "",
        password: "",
        confirmPassword: "",
      },
      rules: {
        required: (v) => !!v || "Required",
        username: (v) => {
          if (!v) return true;
          // simple: 3-20, letras/números/._-
          const ok = /^[a-zA-Z0-9._-]{3,20}$/.test(v);
          return (
            ok ||
            "Use 3–20 characters (letters, numbers, dot, dash or underscore)"
          );
        },
        password: (v) => {
          if (!v) return true;
          // mínimo 8 chars (puedes endurecer después)
          return v.length >= 8 || "Password must be at least 8 characters";
        },
        matchesPassword: (v) => {
          if (!v) return true;
          return v === this.form.password || "Passwords do not match";
        },
      },
    };
  },
  computed: {
    canSubmit() {
      // Para UI rápida: exige que el v-form sea válido
      return (
        this.isValid &&
        !!this.form.username &&
        !!this.form.password &&
        !!this.form.confirmPassword
      );
    },
  },
  watch: {
    invitedEmail: {
      immediate: false,
      handler(val) {
        if (val != null && val !== this.form.email) {
          this.form.email = String(val).trim();
        }
      },
    },
  },
  mounted() {
    this.form.email = (this.invitedEmail && String(this.invitedEmail).trim()) || "";
    if (this.initialUsername) this.form.username = this.initialUsername;
  },
  methods: {
    onSubmit() {
      const ok = this.$refs.form && this.$refs.form.validate();
      if (!ok) return;

      // emite al padre para que llame al backend
      this.$emit("submit", {
        email: this.form.email,
        username: this.form.username,
        password: this.form.password,
      });
    },
    onNext() {
      const ok = this.$refs.form && this.$refs.form.validate();
      if (!ok) return;

      this.$emit("next", { ...this.form });
    },
  },
};
</script>

<style lang="scss" scoped>
.field-block {
  margin-top: 16px;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
  color: rgba(0, 0, 0, 0.75);
}

::v-deep .login-form .v-messages__message {
  margin: 0;
  padding: 0;
}

::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
  padding-top: 0px;
  margin-bottom: 0px;
}

.signup-btn {
  margin-top: 8px;
  border-radius: 10px;
  text-transform: none;
  font-weight: 700;
}

/* Igual que el mock: se ve “mint” y más claro cuando está disabled */
.signup-btn.v-btn--disabled {
  opacity: 0.55;
}

.signup-two__legal {
  margin: 10px 0 0 0;
  font-size: 11px;
  text-align: center;
  color: rgba(0, 0, 0, 0.55);
}
</style>
